import React from "react";
import img404 from "../assets/image/404.webp";
import Button from "../components/form/Button";
import { useTranslation } from "react-i18next";


const PageNotFound = () => {
  const { i18n,t } = useTranslation();
  return (
    <div className="flex h-screen">
      <div className="w-full flex items-center justify-end">
        <div className="relative w-[600px] h-[600px]">
          <img
            width={800}
            height={800}
            src={img404}
            alt="invalid"
            className="w-full h-full object-contain object-center"
          />
        </div>
      </div>
      <div className="w-full flex flex-col justify-center">
        <div className="-ml-18 mt-20 relative">
          <div className="text-3xl font-bold text-dark-teal-500">
            It&apos;s seems you&apos;ve taken a wrong turn
          </div>
          <div className="font-medium my-3">
            the page you&apos;re looking for might have been misplaced,
            <br />
            lost in cyperspace, or it simply doesn&apos;t exiist
          </div>
          {/* <div className="absolute -bottom-60 right-[300px] text-[200px] text-dark-teal-400/40 font-extrabold">
            404
          </div> */}
          <Button
            buttonClasses={"!w-fit !bg-primary !border-primary !text-white"}
            buttonIcon={"fa-regular fa-arrow-left"}
            buttonIconPosition={"left"}
            buttonLabel={t("back_to_home")}
            buttonHasLink={true}
            buttonLink={"/"}
          />
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
